import { jsx as _jsx } from "react/jsx-runtime";
import './style.css';
const AdminDashboard = () => {
    return _jsx("div", { children: "AdminDashboard" });
};
export default AdminDashboard;
